const OrDivider = () => {
    return (
      <div className="relative w-full mb-7 md:mb-8">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200 border-dashed"></div>
        </div>
        <div className="relative flex justify-center">
          <span className="bg-white px-4 text-sm text-gray-500 uppercase">
            OR
          </span>
        </div>
      </div>
    );
};

export default OrDivider